<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt from '@/http/requests/auth/jwt/index.js'

export default {
	data() {
		return {
			vueAppClasses: []
		}
	},
	watch: {
		'$store.state.theme'(val) {
			this.toggleClassInBody(val)
		},
		'$vs.rtl'(val) {
			document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
		}
	},
	methods: {
		toggleClassInBody(className) {
			if (className === 'dark') {
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
				document.body.classList.add('theme-dark')
			} else if (className === 'semi-dark') {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
				document.body.classList.add('theme-semi-dark')
			} else {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
			}
		},
		setAppClasses(classesStr) {
			this.vueAppClasses.push(classesStr)
		},
		handleWindowResize() {
			this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

			// Set --vh property
			document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
		},
		handleScroll() {
			this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
		}
	},
	mounted() {
		this.toggleClassInBody(themeConfig.theme)
		this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

		const vh = window.innerHeight * 0.01
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${vh}px`)
	},
	created() {

		const dir = this.$vs.rtl ? 'rtl' : 'ltr'
		document.documentElement.setAttribute('dir', dir)

		window.addEventListener('resize', this.handleWindowResize)
		window.addEventListener('scroll', this.handleScroll)
		const data = []
		data["ROLE"] = localStorage.getItem("ROLE");
		data['servisAdresi'] = localStorage.getItem("servisAdresi");
		data['fullFilmentTokenId'] = localStorage.getItem("fullFilmentTokenId");
		data["userCode"] = localStorage.getItem("userCode");
		data["userName"] = localStorage.getItem("userName");
		data["expiration"] = localStorage.getItem("expiration");
		data["userId"] = localStorage.getItem("userId");
		data["companyid"] = localStorage.getItem("companyid");

		let jsondata = {
			ROLE: localStorage.getItem("ROLE"),
			servisAdresi: localStorage.getItem("servisAdresi"),
			fullFilmentTokenId: localStorage.getItem("fullFilmentTokenId"),
			userCode: localStorage.getItem("userCode"),
			userName: localStorage.getItem("userName"),
			expiration: localStorage.getItem("expiration"),
			userId: localStorage.getItem("userId"),
			companyid: localStorage.getItem("companyid")
		}
		this.$store.commit("setToken", data);
		localStorage.setItem("ROLE", data["ROLE"]);
		localStorage.setItem("servisAdresi", data["servisAdresi"]);
		localStorage.setItem("fullFilmentTokenId", data["fullFilmentTokenId"]);
		localStorage.setItem("userCode", data["userCode"]);
		localStorage.setItem("userName", data["userName"]);
		localStorage.setItem("expiration", data["expiration"]);
		localStorage.setItem("userId", data["userId"]);
		localStorage.setItem('userInfoAuth', JSON.stringify(jsondata))
		let langVal = localStorage.getItem("userLanguage") 
		if (langVal == "en-US" || langVal == null || langVal == "null" || typeof langVal == "undefined") {
 
			localStorage.setItem("userLanguage", "tr")
			this.$router.go()
		} 
		localStorage.setItem("userLanguage", localStorage.getItem("userLanguage"));  
		localStorage.setItem('companyid', data["companyid"])
		this.$store.dispatch("auth/getData").then(response => {
			if (response == true) {
			}
		})
	},
	destroyed() {
		window.removeEventListener('resize', this.handleWindowResize)
		window.removeEventListener('scroll', this.handleScroll)
	}
}

</script>
<style lang="scss">
[dir] .router-view {
	padding: 2.2rem 2.2rem 0rem 2.2rem !important;
}
</style>

